/*
 * @Author: ezhizao 庄德政
 * @LastEditors: ezhizao 庄德政
 * @Description: 
 */
const routers = [{
    // 供求类别列表
    path: '/equipment/categorylist',
    name: 'equipment_category_list',
    component: () => import('./CategoryList.vue')
  },
  {
    // 供求类别表单
    path: '/equipment/categoryform/:id?',
    name: 'equipment_category_form',
    component: () => import('./CategoryForm.vue')
  },
  {
    // 供求列表
    path: '/equipment/list',
    name: 'equipment_list',
    component: () => import('./List.vue')
  },
  {
    // 供求表单
    path: '/equipment/form/:id?/:categoryId?',
    name: 'equipment_form',
    component: () => import('./Form.vue')
  }
]
export default routers